import { HomepageThemeProvider } from '@codex-applications/homepage';
import React from 'react';
import ReactDOM from 'react-dom';
import HomepageModuleWrapper from './HomepageModuleWrapper';

function init(customerId, customerEmail, customerIsGuest) {
  const roots = document.querySelectorAll('[data-component="HomepageModule"][data-auto-init]');

  if (roots.length <= 0) {
    return;
  }

  Array.from(roots).forEach((root) => {
    ReactDOM.render(
      <HomepageThemeProvider>
        <HomepageModuleWrapper
          customerId={customerId}
          customerEmail={customerEmail}
          dispatch={window.appState.dispatch}
          isGuest={customerIsGuest}
        />
      </HomepageThemeProvider>,
      root
    );
    root.removeAttribute('data-auto-init');
  });
}

export default { init };
